import { OnMessageCallback } from 'mqtt';
import { store } from '../../app/store';
import { transferActions } from './transferSlice';

export const transferMqttParser: OnMessageCallback = (topic: any, payload: any, packet: any): void => {
    store.dispatch(transferActions.new_transfer_messages({ ...JSON.parse(payload.toString()) }));
};